import axios from '@/utils/axiosHelper'

// 初始化
export const onInitAPI = (params) => {
    return axios({ url: '/sword/celebration/init', method: 'GET', params }, { interceptResultCode: false })
}

// 未登录数据显示
export const onShowAPI = (params) => {
    return axios({ url: '/sword/celebration/show', method: 'GET', params }, { interceptResultCode: false })
}

// 一键领取
export const onRewardAPI = (params) => {
    return axios({ url: '/sword/celebration/reward', method: 'GET', params }, { interceptResultCode: false })
}

// 完成任务
export const onClickAPI = (params) => {
    return axios({ url: '/sword/celebration/click', method: 'POST', params }, { interceptResultCode: false })
}

// 领取能量
export const onTaskAPI = (params) => {
    return axios({ url: '/sword/celebration/task', method: 'POST', params }, { interceptResultCode: false })
}

// 注销
export const onLogoutAPI = (params) => {
    return axios({ url: '/game/my/disable', method: 'POST', params }, { interceptResultCode: false })
}

// 免登录
export const onAutoAPI = (params) => {
    return axios({ url: '/game/login/free', method: 'POST', params }, { interceptResultCode: false })
}


// WEBPACK FOOTER //
// ./src/pages/hjwq/crossYear/api.js